export default "__VITE_ASSET__DHdkAGVQ__"